import { mutatorAction } from "satcheljs";
import type SearchScenarioId from "../store/schema/SearchScenarioId";
import getScenarioStore from "../selectors/getScenarioStore";

const setSearchHitHighlightingEnabledMutator: (scenarioId: SearchScenarioId, isEnabled: boolean) => void = mutatorAction("setSearchHitHighlightingEnabled", (scenarioId: SearchScenarioId, isEnabled: boolean): void => {
    getScenarioStore(scenarioId).isHitHighlightingEnabled = isEnabled;
});

export default setSearchHitHighlightingEnabledMutator;
